import React from 'react'
import {
  TabbedForm,
  FormTab,
  TextInput,
  ImageInput,
  ImageField,
  BooleanInput,
  DateInput,
} from 'react-admin'
import { CitiesSelect } from '../../components/custom'
import RichTextInput from 'ra-input-rich-text'

const TournamentForm = (props) => {
  return (
    <TabbedForm {...props} label='Создания турнира'>
      <FormTab label='Турнир'>
        <TextInput fullWidth={true} source='sportKind' label='Вид спорта' />
        <TextInput fullWidth={true} source='name' label='Название' />
        <TextInput
          fullWidth={true}
          source='shortName'
          label='Короткое название'
        />
        <ImageInput
          source='poster'
          label='Постер'
          accept='image/*'
          placeholder='Нажмите для выбора изображения'
        >
          <ImageField source='src' title='title' />
        </ImageInput>
        <CitiesSelect isEdit={props.isEdit} />
        <TextInput fullWidth={true} source='address' label='Адрес' />
        <TextInput fullWidth={true} source='place' label='Место' />
        <TextInput fullWidth={true} source='site' label='Сайт' />
        <TextInput fullWidth={true} source='vk' label='vk' />
        <TextInput fullWidth={true} source='youtube' label='youtube' />
        
        <DateInput
          fullWidth={true}
          source='dateStart'
          label='Дата начала турнира'
        />
        <DateInput
          fullWidth={true}
          source='dateEnd'
          label='Дата конца турнира'
        />
        <DateInput
          fullWidth={true}
          source='registerDateStart'
          label='Дата начала регистрации'
        />
        <DateInput
          fullWidth={true}
          source='registerDateEnd'
          label='Дата конца регистрации'
        />
        <DateInput
          fullWidth={true}
          source='earlyRegisterDateStart'
          label='Раннее начало регистрации'
        />
        <DateInput
          fullWidth={true}
          source='lateRegisterDateEnd'
          label='Поздний конец регистрации'
        />
        
        <BooleanInput
          source='isStarted'
          label='Статус верификации'
          fullWidth={true}
        />
      </FormTab>
      <FormTab label='Описание турнира'>
        <RichTextInput source='description' label='Описание' />
      </FormTab>
    </TabbedForm>
  )
}

export default TournamentForm